// Converted from application/views/sculptures/mother&child-bronze_v.php. Edit this component directly.
export default function SculpturesMotherChildBronzePage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/bronze/Mother&Child-Bronze-with-sculpture-paddy-campbell.jpg"} alt={"Paddy Campbell next to Mother & Child"} />
<figcaption>{"Paddy Campbell next to Mother & Child"}</figcaption>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Mother & Child"}</h1>
<h2>{"\n                    In Bronze\n                "}</h2>
<p>
<b>{"75 x 75 x 78 cm"}</b><br />{"\n                    29.5” x 29.5” x 30.7”"}<br />{"\n                    Bronze"}<br />{"\n                    No. in Series 6\n                "}</p>
<p class={"calltoaction"}><a href={"/c/sculpture/mother&child-story"}>
<img src={"/icons/book.svg"} alt={"read the story"} class={"iconBook"} />{"\n                        Read the story of how Mother & Child was made"}</a></p>
</div>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/bronze/Mother&Child-Bronze-closeup.jpg"} alt={"A closeup of the scultpure"} />
<figcaption>{"A closeup of the scultpure"}</figcaption>
</figure>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                The original sculpture in wax was made at Paddy Campbell’s studio at Fairview, Dublin, in 2005.  It was cast in bronze and exhibited in many venues, in Ireland, UK,Greece,  and Italy, before being carved in Cararra marble in 2015.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/bronze/Mother&Child-Bronze-head-closeup.jpg"} alt={"A Closeup of the sculpture head"} />
<figcaption>{"A Closeup of the sculpture head"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/bronze/Mother&Child-Bronze-baby-feet-closeup.jpg"} alt={"The Baby's feet"} />
<figcaption>{"The Baby's feet"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                The mother, Emily, and her daughter Coco now live in Margate in the South of England, and take a keen interest in how the sculpture is doing.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                The Cararra marble version (unique) has found a permanent home at the “Museo degli Innocenti” in Piazza Santissima Annunciata, Florence.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/bronze/Mother&Child-Bronze-baby-closeup.jpg"} alt={"The Baby"} />
<figcaption>{"The Baby"}</figcaption>
</figure>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/bronze/Mother&Child-Bronze-head-closeup2.jpg"} alt={"Paddy Campbell making the “baby“ Coco in wax while Emily took a break"} />
</figure>
</div>
<div class={"container fullPhoto"}>
<div class={"text"}>
<div style={{"flexDirection":"column","justifyContent":"center","maxWidth":"80%","height":"20rem","display":"flex","alignItems":"center"}}>
<blockquote style={{"textAlign":"center"}}>{"“The time I spent making Mother and Child with Emily and Coco was as near as a man can get to motherhood”"}</blockquote>
<p>{"Paddy Campbell, March 2005"}</p>
</div>
</div>
</div>
</>;
}
